import styled from 'styled-components';

export const $ToolTipFormatter = styled.div`
  white-space: break-spaces;
  text-align: left;
`;
